var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pswp",
      attrs: { tabindex: "-1", role: "dialog", "aria-hidden": "true" },
      on: {
        mousewheel: function($event) {
          $event.preventDefault()
        },
        touchmove: function($event) {
          $event.preventDefault()
        },
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c("div", { staticClass: "pswp__bg" }),
      _c("div", { staticClass: "pswp__scroll-wrap" }, [
        _vm._m(0),
        _c("div", { staticClass: "pswp__ui pswp__ui--hidden" }, [
          _c("div", { staticClass: "pswp__top-bar" }, [
            _c("div", { staticClass: "pswp__counter" }),
            _c("button", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.options.showClose,
                  expression: "options.showClose"
                }
              ],
              staticClass: "pswp__button pswp__button--close",
              attrs: { title: "Close (Esc)" }
            }),
            _c("button", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.options.showShare,
                  expression: "options.showShare"
                }
              ],
              staticClass: "pswp__button pswp__button--share",
              attrs: { title: "Share" }
            }),
            _c("button", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.options.showFullscreen,
                  expression: "options.showFullscreen"
                }
              ],
              staticClass: "pswp__button pswp__button--fs",
              attrs: { title: "Toggle fullscreen" }
            }),
            _c("button", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.options.showZoom,
                  expression: "options.showZoom"
                }
              ],
              staticClass: "pswp__button pswp__button--zoom",
              attrs: { title: "Zoom in/out" }
            }),
            _vm._m(1)
          ]),
          _vm._m(2),
          _c("button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.options.showArrow,
                expression: "options.showArrow"
              }
            ],
            staticClass: "pswp__button pswp__button--arrow--left",
            attrs: { title: "Previous (arrow left)" }
          }),
          _c("button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.options.showArrow,
                expression: "options.showArrow"
              }
            ],
            staticClass: "pswp__button pswp__button--arrow--right",
            attrs: { title: "Next (arrow right)" }
          }),
          _c(
            "div",
            {
              staticClass: "pswp__caption",
              on: {
                MSPointerDown: _vm.onCaptionDown,
                MSPointerMove: _vm.onCaptionMove,
                MSPointerUp: _vm.onCaptionUp,
                pointerdown: _vm.onCaptionDown,
                pointermove: _vm.onCaptionMove,
                pointerup: _vm.onCaptionUp,
                touchstart: _vm.onCaptionDown,
                touchmove: _vm.onCaptionMove,
                touchend: _vm.onCaptionUp,
                mousedown: _vm.onCaptionDown,
                mousemove: _vm.onCaptionMove,
                mouseup: _vm.onCaptionUp
              }
            },
            [_c("div", { staticClass: "pswp__caption__center" })]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pswp__container" }, [
      _c("div", { staticClass: "pswp__item" }),
      _c("div", { staticClass: "pswp__item" }),
      _c("div", { staticClass: "pswp__item" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pswp__preloader" }, [
      _c("div", { staticClass: "pswp__preloader__icn" }, [
        _c("div", { staticClass: "pswp__preloader__cut" }, [
          _c("div", { staticClass: "pswp__preloader__donut" })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "pswp__share-modal pswp__share-modal--hidden pswp__single-tap"
      },
      [_c("div", { staticClass: "pswp__share-tooltip" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }